<div class="cont">
    <div class="header1">
        <div style="font-size: 18px;font-weight: 600;color:var(--coraldarkgrey)" multilang>
            Hoteldetails
        </div>
        <button class="close" (click)="closePanel()">
            <mat-icon style="font-size: 24px;">close</mat-icon>
        </button>
    </div>
    <div class="header2">
        <div class="tabs">
            @for(tab of tabs;track $index){
            @if(tab === 'Bewertung') {
            @if(!(hotel?.giata?.hotelId === '4869' ||
            hotel?.giata?.hotelId === '11280' ||
            hotel?.giata?.hotelId === '95751' ||
            hotel?.giata?.hotelId === '11280' ||
            hotel?.giata?.hotelId === '4869' ||
            hotel?.giata?.hotelId === '95751' ||
            hotel?.giata?.hotelId === '265658' ||
            hotel?.giata?.hotelId === '4868' ||
            hotel?.giata?.hotelId === '4867' ||
            hotel?.giata?.hotelId === '265658')) {
            <button class="tab" [class.tab-sel]="selectedTab==tab" (click)="navigate($index)">
                <div class="text-wrap" multilang>
                    {{tab}}
                </div>
            </button>
            }

            } @else {
            <button class="tab" [class.tab-sel]="selectedTab==tab" (click)="navigate($index)">
                <div class="text-wrap" multilang>
                    {{tab}}
                </div>
            </button>
            }
            }
        </div>
    </div>
    <div class="modalbodypopup">
        @switch(selectedTab){
        @case("Beschreibung"){
        <div class="custom-scrollable">
            <ng-container *ngTemplateOutlet="beschreibung"></ng-container>
        </div>
        }
        @case("Ausstattung")
        {<ng-container *ngTemplateOutlet="ausstattung"></ng-container>}
        @case("Bewertung"){
        <app-hotelReview [data]="data"></app-hotelReview>
        }
        @case("Karte"){
        <div class="karte">
            <details-map [hotel]="hotel" [mode]="res.mode"></details-map>
        </div>
        }
        }
    </div>
    <div class="button-cont">
        <button class="det-but" (click)="dialogRef.close()" multilang>Zurück</button>
        @if(res.func){
        <button class="det-but ok-but" (click)="onReg()" multilang>Angebote ab {{hotel.bestPricePerPerson?.value}}
            €p.P.</button>
        }
    </div>
</div>




<ng-template #beschreibung>
    <div class="containermodaldetail">
        <span multilang class="title">Hotelbeschreibung: </span>
        <div class="feature hide">
            <img class="image" [src]='hotel.mediaData.imageList?.[0] | cacheResource' />
            <div class="contents">
                <div class="sub-cont">
                    <span multilang class="subtitle">{{hotel.name}}</span>
                    <div style="display:flex;">
                        @for(cat of hotel.categoryArr;track $index){
                        @if(cat === 1){
                        <img src="../../../../assets/icons/Star.svg" alt="">
                        }@else{
                        <img src="../../../../assets/icons/halfstar.svg" alt="">
                        }

                        }
                    </div>
                </div>
                <div class="location" multilang>{{hotel.location.name}} / {{hotel.location.region.name}}</div>
                <div id="amenities" class="amenities">
                    @for(feature of features;track $index){
                    @if($index < 6){ <span multilang class="pill">
                        <span multilang
                            style="background-color:var(--coralblue);padding:0.5rem;border-radius:50%;color:#fff"
                            *ngIf="feature.name && feature.code !== 'ado'" [class]="feature.icon"
                            [matTooltip]="feature.name" matTooltipClass="matTooltip"></span>
                        <mat-icon style="background-color:var(--coralblue);padding:0.5rem;border-radius:50%;color:#fff"
                            *ngIf="feature.code==='ado'">wc</mat-icon>
                        <span multilang class="text text-color">{{feature.name}}</span>
                        </span>
                        }}
                </div>
            </div>
        </div>
        <div multilang deeplMode="html" [innerHTML]="offerObj?.html | safehtml" class="vorteile">
        </div>
    </div>
</ng-template>



<ng-template #ausstattung>
    <div class="containermodaldetail">
        <span multilang class="title">Hotelausstattung im Überblick:</span>
        <div class="feature width100" style="justify-content: center;height: calc(100% - 44px);">
            <div class="info">
                <div class="beliebeste">Beliebteste Ausstattung</div>
                <div id="amenities" class="amenities amenities2">
                    @for(feature of features;track $index){
                    <div class="amenity">
                        <span
                            style="background-color:var(--coralblue);padding:0.5rem;border-radius:50%;color:#fff;width:2rem;height:2rem;"
                            *ngIf="feature.name && feature.code !== 'ado'" [class]="feature.icon"
                            [matTooltip]="feature.name" matTooltipClass="matTooltip"></span>
                        <mat-icon
                            style="background-color:var(--coralblue);padding:0.5rem;border-radius:50%;width:28px;height:28px;color:#fff"
                            *ngIf="feature.code==='ado'">wc</mat-icon>
                        <span multilang class="text text-color">{{feature.name}}</span>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-template>